import { defaultColorNames } from '@tldraw/tlschema'
import { parseName } from './graph'
import { nodeColors } from '@/lib/nodeColors'

const classNames = [
  'inst_valv_Welded_gate_valve',
  'inst_valv_Plug_valve',
  'inst_valv_Globe_valve_NO',
  'inst_valv_Gate_valve_NO',
  'inst_valv_Ball_valve',
  'inst_valv_Butterfly_Valve',
  'inst_valv_Manual_gate_valve',
  'inst_valv_Check_valve',
  'inst_valv_Diaphragm_valve',
  'inst_valv_Needle_Valve',
  'inst_valv_Sealing_gate_valve',
  'inst_valv_Gate_valve_NC',
  'inst_valv_Globe_valve_NC',
  'inst_valv_Control_Valve',
  'inst_valv_Rotary_valve_NO',
  'inst_valv_Rotary_valve_NC',
  'pip_fit_Spade_blind',
  'pip_fit_Spade_close_blind_(flanged)',
  'pip_fit_Spade_open_blind(flanged)',
  'pip_fit_Right_concentric_reducer',
  'pip_fit_Flanged_connection',
  'pip_fit_Heating_coil_tubes',
  'pip_fit_Jacketed_pipe',
  'pip_fit_Mid_arrow_flow_direction',
  'inst_valv_Circle_valve',
  'inst_ind_Field_mounted_discrete_indicator',
  'inst_ind_Field_mounted_discrete_recorder',
  'inst_ind_discrete_with_Pri._Loc_access',
  'inst_ind_discrete_with_Aux_Loc_access',
  'inst_ind_Solenoid_actuator',
  'inst_ind_shared_with_Pri._Loc_access',
  'inst_ind_shared_control_logic',
  'inst_ind_Programmable_with_Pri._Loc_access',
  'eqp_ves_reaction_drum',
  'eqp_gen_Fan',
  'pip_endp_Pagination',
  'eqp_htx_Finned_heat_exchanger',
  'eqp_htx_Feed_gas_cooler',
  'inst_valv_Flanged_rotary_valve_NO',
  'pip_fit_Exhaust_Silencer',
  'eqp_Compressor_Booster_compressor',
  'pip_endp_Point_to_Different_P_&_ID',
  'inst_valv_Hand_operated_2-way_valve',
  'inst_valv_safety_2-way_valve',
  'inst_valv_3-way_valve',
  'pip_fit_Orifice_plate',
  'pip_endp_Connector_block',
  'inst_valv_Relief_valve',
  'pip_fit_Seperator',
  'inst_valv_Non-insulated_gate_valve_NO',
  'eqp_gen_Axial_flow_fan',
  'PIP_Major',
  'Inlet_outlet2',
  'Inlet_Outlet',
  'INO_S1',
  'INO_S2',
  'INO_S3',
  'SIG_Electroninc_Sonic_NG',
  'SIG_Electronic_Sonic',
  'SIG_Pnuemtic',
  'SIG_Electric',
  'SIG_Hydraulic',
  'SIG_Undefined',
  'TUBE_Capilary',
  'Mechanical',
  'Link4',
  'Link3',
  'Link2',
  'Link1',
  'VES_Bin',
  'VES_Wast-water_treatment',
  'VES_Electrical_Heating_Vessel',
  'VES_Pit_Vessel',
  'VES_Dish_Ends_Vessel',
  'VES_Baskets_Vessel',
  'VES_Heating-cooling_Jacket_Vessel',
  'VES_Thermal_Insulation_Vessel',
  'VES_Onion_Tank',
  'VES_Double_Wall_Tank',
  'VES_Internal_Floating_Roof_Tank',
  'VES_one_Roof_Tank',
  'VES_Dome_Roof_Tank',
  'VES_Open_Bulk_Storage',
  'VES_Floating_Roof_Tank',
  'VES_Covered_Tank',
  'VES_Open_Tank',
  'VES_Tank_IV',
  'VES_Tank_III',
  'VES_Tank_II',
  'VES_Tank',
  'VES_Hot_Liquid_Boiler',
  'VES_Boiler',
  'VES_Gas_Bottle',
  'VES_ISO_Barrel',
  'VES_Barrel',
  'VES_Bag',
  'VES_ISO_Bag',
  'VES_Knock-out_Drum',
  'VES_Drum',
  'VES_Packing_Column_II',
  'VES_Packing_Column',
  'VES_Staggered_Baffle_Trays_Column',
  'VES_Fluidized_Bed_Column',
  'VES_Tray_Column',
  'VES_Column',
  'VES_Mising_Vessel',
  'VES_Vertical_Vessel',
  'VAL_Self-Operating_Release_Valve',
  'VAL_Water_Flow_Meter',
  'VAL_Quarter_Turn_Spring_Acting',
  'VAL_Quarter_Turn_Double_Acting',
  'VAL_Rotameter',
  'VAL_Orifice',
  'VAL_Manual_INtegrated_Valve',
  'VAL_Integrated_Block_Valve',
  'VAL_Bleeder',
  'VAL_Gauge',
  'VAL_Auto_Recirculation',
  'VAL_Minimum_Flow_Valve',
  'VAL_Pinch_Valve',
  'VAL_Diaphragm_Valve_i',
  'VAL_Self_Draining_Valve',
  'VAL_Post_Indicator',
  'VAL_Excess_Flow_Valve',
  'VAL_Knife_Valve',
  'VAL_Metering_Coke',
  'VAL_Slide_Valve',
  'VAL_Ram_Valve',
  'VAL_Spting_Gate_Valve',
  'VAL_Balanced_Diaphragm_Gate_Valve',
  'VAL_Elctro_Hydraulic_Valve',
  'VAL_4-Way_Vavle',
  'VAL_4-Way_Plug_Valve',
  'VAL_3-Way_Plug_Valve',
  'VAL_3-Way_Valve_2',
  'VAL_3-Way_Valve',
  'VAL_Manual_Needle_Valve',
  'VAL_Float_Operated_Valve',
  'VAL_Powered_Valve',
  'VAL_Weight_Gate_Valve',
  'VAL_Pilot_Gate_Valve',
  'VAL_Motor_Operated_Valve',
  'VAL_Hydraulic_Valve',
  'VAL_Solenoid_Valve',
  'VAL_Plug_Valve',
  'VAL_Diaphragm_Ball_Valve',
  'VAL_Normally_Closed_Ball_Valve',
  'VAL_Ball_Valve',
  'VAL_Angle_Blowdown_Valve',
  'VAL_Angle_Valve',
  'VAL_Relief_Valve',
  'VAL_Manual_Agle_Valve',
  'VAL_Flanged_Valve_2',
  'VAL_Flanged_Valve',
  'VAL_Butterfly_Valve',
  'VAL_Check_Valve_2',
  'VAL_Check_Valve',
  'VAL_Plug_or_Check_Valve',
  'VAL_Back_Pressure_Regulator',
  'VAL_Piston_Operated_Valve',
  'VAL_Control_Valve',
  'VAL_Needle_Valve',
  'VAL_Roraty_Valve',
  'VAL_Globe_Valve',
  'VAL_Manual_Globe_Valve',
  'VAL_Closed_Gate_Valve',
  'VAL_Gate_Valve',
  'VAL_Manual_Gate_Valve',
  'PUM_Motor',
  'PUM_Positive_displacement_pump',
  'PUM_Pump',
  'PUM_Selectable_Compressor',
  'PUM_ISO_Gear_Pump',
  'PUM_ISO_reciprocating_piston_pump',
  'PUM_ISO_positive_displacement_pump',
  'PUM_ISO_Progressive_pump',
  'PUM_ISO_diaphragm_pump',
  'PUM_ISO_centrifugal_pump',
  'PUM_ISO_Liquid_Pump',
  'PUM_Disel_Motor',
  'PUM_Spray',
  'PUM_Ejector',
  'PUM_Motor-driven_Turbine',
  'PUM_Doubleflow_Turbine',
  'PUM_Turbine_Driver',
  'PUM_Axial_Flow_Fan',
  'PUM_Triple_Fan_Blades',
  'PUM_Fan_Blades_II',
  'PUM_Fan_Blades',
  'PUM_Selectable_Fan',
  'PUM_Fan',
  'PUM_Pump_II',
  'PUM_Turbine_Pump',
  'PUM_Reciprocating_pump_II',
  'PUM_Reciprocating_pump',
  'PUM_Submersible_pump',
  'PUM_Cavity_Pump',
  'PUM_Screw_Pump_II',
  'PUM_Screw_Pump',
  'PUM_Vaccum_Pump',
  'PUM_Proportioning_pump',
  'PUM_Gear_Pump',
  'PUM_Peristaltic_pump',
  'PUM_Rotary_Gear_Pump',
  'PUM_Rotary_Pump',
  'PUM_Positive_displacement_pump_II',
  'PUM_Sump_Pump',
  'PUM_Vertical_Pump_II',
  'PUM_Horizontal_Pump',
  'PUM_Liquid_ring_vacuum_pump',
  'PUM_Vertical_Pump',
  'PUM_Gate_Blower',
  'PUM_Centrifugal_Pump_IV',
  'PUM_Centrifugal_Pump_III',
  'PUM_Centrifugal_Pump_II',
  'PUM_Centrifugal_Pump',
  'PUM_Axial_Copressor',
  'PUM_Centrifugal_Blower',
  'PUM_Centrifugal_Compressor_III',
  'PUM_Centrifugal_Compressor_II',
  'PUM_Centrifugal_Compressor',
  'PUM_Liquid_Ring_Compressor',
  'PUM_Rotory_Compressor_and_silencers',
  'PUM_Rotary_Compressor_II',
  'PUM_Rotary_Compressor',
  'PUM_Centrifugal',
  'PUM_Compressor_Silencer',
  'PUM_Reciprocating_Compressor_II',
  'PUM_Reciprocating_Compressor',
  'PUM_Compressor',
  'PIC_Valve-Manifol',
  'PIC_Fire-Resitant_Flame_Arrestor',
  'PIC_Detonation-Proof_Flame_Arrestor',
  'PIC_Explotion-Proof_Flame_Arrestor_Flame_Arrestor',
  'PIC_Flame_Arrestor',
  'PIC_Electrically_Insulated_II',
  'PIC_Coupling',
  'PIC_Compenstae',
  'PIC_Clamped_Flange_Coupling',
  'PIC_Orifice_II',
  'PIC_Breakthrough',
  'PIC_Damper',
  'PIC_Breather_II',
  'PIC_Bucket_Strainer',
  'PIC_Removable_Spool',
  'PIC_Bell_Mouth',
  'PIC_Flow_Indicator',
  'PIC_Flexible_Hose',
  'PIC_Hose',
  'PIC_Expansion_Joint_II',
  'PIC_Exhaust_Head_II',
  'PIC_Ejector_or_Eductor',
  'PIC_Desuperheater',
  'PIC_Steam_Trap',
  'PIC_In-line_Silencer',
  'PIC_Detonation_Arrestor',
  'PIC_Swivel_Joint',
  'PIC_Hydrant',
  'PIC_Syphon_Drain',
  'PIC_Open_Vent',
  'PIC_Tundish',
  'PIC_Triangle_Separator_II',
  'PIC_Triangle_Separator',
  'PIC_Exhaust_Head',
  'PIC_Strainer',
  'PIC_Exhaust_Silencer',
  'PIC_Drain_Silencer',
  'PIC_Flane_Arrester',
  'PIC_Bursting_Disc',
  'PIC_Seprator',
  'PIC_In-line_Mixer',
  'PIC_Electrically_Insulated',
  'PIC_Pilot_Operated_Relief_Valve_with_Remote_Sensor',
  'PIC_Cone_Strainer',
  'PIC_Basket_Strainer',
  'PIC_Vent_Silencer',
  'PIC_Duplex_Strainer',
  'PIC_Paulsation_Dampener',
  'PIC_Reducer',
  'PIC_Slope_Requirements_line',
  'PIC_Electrical_Bounded',
  'PIC_Flanged_Dummy_Cover',
  'PIC_Orifice_Plate',
  'PIC_Screwed_Connection',
  'PIC_Socket_Weld',
  'PIC_Union',
  'PIC_Flange_II',
  'PIC_Drip_Pan_Elbow',
  'PIC_Breather',
  'PIC_End_Cap_II',
  'PIC_End_Cap',
  'PIC_Flange',
  'PIC_Double_Contaiment',
  'PIC_Open_Disc',
  'PIC_Interchangable_Blind',
  'PIC_Spectacle_Blind',
  'PIC_Blind_Disc',
  'PIC_Soldered-Solvent',
  'PIC_Mechanical_Link',
  'PIC_Welded_Connection',
  'PIC_Butt_Weld',
  'PIC_Sleeve_Joint',
  'PIC_Electric_Binary_Signal_Line',
  'PIC_Electric_Signal_Line',
  'PIC_Pneumatic-Binary_Signal_Line',
  'PIC_Pneumatic_Control',
  'PIC_Nuclear',
  'PIC_Sonic_Signal',
  'PIC_Top-to-top',
  'PIC_Expansion_Joint',
  'PIC_Rotary_valve',
  'PIC_Y-type_Strainer',
  'PIC_Driver_Valve',
  'PIC_Y-strainer',
  'PIC_Multi-line_Elbow',
  'PIC_Mid_Arroow',
  'PIC_Multi_line',
  'PIC_Traced-line',
  'PIC_One-to-many',
  'PIC_Top-bottom',
  'PIC_Side-by-side',
  'PIC_Heat_Trace',
  'PIC_Electronic_Serial',
  'PIC_Battery-limit_line',
  'PIC_Straight-line_Pipeline',
  'PIC_Major_Straight_Pipeline',
  'PIC_Connect_Pipeline',
  'PIC_Major_Pipeline',
  'PER_Conveyor_Vibrating_Closed',
  'PER_Chimney',
  'PER_Palletzer',
  'PER_Flame_Arrestor',
  'PER_Firing_System',
  'PER_Curved_Gas_Vent',
  'PER_Cyclone',
  'PER_Crane',
  'PER_Roller_Press',
  'PER_Piston_Press',
  'PER_Pelletizing_Disc',
  'PER_Vertical_Shaping_Machines',
  'PER_Horizontal_Shaping_Machines',
  'PER_PScrew_Extruder_Shaping_Machines',
  'PER_Piston_Extruder_Shaping_Machines',
  'PER_Scraper_Conveyor',
  'PER_Screw_Conveyor',
  'PER_Over-head_Conveyor',
  'PER_Roller_Conveyor',
  'PER_Conveyor_Screw_Closed',
  'PER_Conveyor_Chain_Closed',
  'PER_Conveyor',
  'PER_Skip_Hoist',
  'PER_Elevator_II',
  'PER_Gas_Flare',
  'PER_Elevator_I',
  'PER_Bucket_Elevator',
  'PER_Screening',
  'PER_Belt_Skimmer',
  'PER_Bag-filling_Machine',
  'PER_Aerator-with_separator',
  'PER_Hoists',
  'PER_Lift',
  'PER_Z-fold_Elevator',
  'PER_Elevator',
  'PER_Ship',
  'PER_Rolling_Bin_Truck',
  'PER_Industrial_Truck',
  'PER_Truck_Forklift',
  'PER_Manual_Forklift',
  'PER_Box_Truck',
  'PER_Back_Draft_Damper',
  'PER_Viewing_Glass_with_Lighting',
  'PER_Viewing_Glass',
  'PER_Rupture_Disc',
  'PER_Reducer',
  'PER_Injector',
  'PER_Metering_Proportional_Feeder',
  'PER_Rotary_Valve_Feeder',
  'PER_Prportional_Feeder',
  'PER_Rotarry_Table_Feeder',
  'PER_Spray_Nozzle',
  'PER_Permanent_Magnet',
  'PER_Solidifier',
  'PER_Electro-static_Separator',
  'PER_Electro-magnetic_Separator',
  'PER_Cyclone_Separator',
  'PER_Gravity_Separator',
  'PER_Impact_Separator',
  'MOT_Turbine',
  'MOT_Electric_Motor',
  'MOT_Disel_Motor',
  'MOT_Motor_II',
  'MOT_Motor-driven_Turbine',
  'MOT_Motor_Operatad_Valve',
  'MOT_DC_Generator',
  'MOT_AC_Generator',
  'MOT_Generator',
  'MOT_AC_Motor',
  'MOT_DC_Motor',
  'MOT_Step_Motor',
  'MOT_Motor',
  'MIX_Agitator_Cross-beam',
  'MIX_Agitator_Disc',
  'MIX_Agitator_Gat_Paddle',
  'MIX_Agitator_Helical',
  'MIX_Turbine',
  'MIX_Agitator_Impeller',
  'MIX_Agitator_Anchor',
  'MIX_Agitator_Propeller',
  'MIX_Agitator_Stirrer',
  'MIX_Various_Mixers_III',
  'MIX_Various_Mixers_II',
  'MIX_Various_Mixers',
  'MIX_Mixer',
  'MIX_In-line_Mixer',
  'INS_Support_Skirt',
  'INS_Support_Ring',
  'INS_Support_Leg',
  'INS_Support_Bracket',
  'INS_Socket_Connection',
  'INS_Manhole',
  'INS_Flume_Meter',
  'INS_Flow_Nozzle_Meter',
  'INS_Coriolis_Flow_Sensor',
  'INS_Level_Meter',
  'INS_Averaging_Pitot_Tube',
  'INS_Thermo_Meter',
  'INS_Pressure_Guages',
  'INS_Diamond',
  'INS_Correcting_Element',
  'INS_Not_Gate',
  'INS_Or_Gate',
  'INS_And_Gate',
  'INS_Vortex_Sensor',
  'INS_Flowmeter',
  'INS_Venturi',
  'INS_Steamed_Traced',
  'INS_Double_Meter',
  'INS_Roto_Meter',
  'INS_Turbine_Meter',
  'INS_Quick_Change',
  'INS_Venturi_Meter',
  'INS_V-cone_Meter',
  'INS_Ultrasonic_Meter',
  'INS_Weir_Meter',
  'INS_Target_Meter',
  'INS_Wedge_Meter',
  'INS_Pitot_Tube',
  'INS_Pitot_Tube_Type_Flow',
  'INS_Magnet',
  'INS_Rotary_Meter',
  'INS_Diaphragm_Meter',
  'INS_Straightening_Vanes',
  'INS_Sampler',
  'INS_Speciality_Item',
  'INS_Transducer',
  'INS_Analyzer_Transmmiter',
  'INS_Level_Guage',
  'INS_Temperature_Element',
  'INS_Flow_Element',
  'INS_Level_Alarm',
  'INS_Pressure_Recording',
  'INS_Pressure_Indicating',
  'INS_Pressure_Conroler',
  'INS_Level_Cotroler',
  'INS_Level_Recorder',
  'INS_Level_Transmitter',
  'INS_Pressure_Indicator',
  'INS_Level_Indicator',
  'INS_Flow_Controler',
  'INS_Flow_Recorder',
  'INS_Flow_Transmitter',
  'INS_Flow_Indicator',
  'INS_Temp_Recorder',
  'INS_Temp_Transmmiter',
  'INS_Temp_Controler',
  'INS_Temp_Indicator',
  'INS_Unit_Control_Panel',
  'INS_Computer',
  'INS_Displayed_Programmable_Device',
  'INS_Programmable_Indicator',
  'INS_Displayed_configurable',
  'INS_Shared_Indicator',
  'INS_Thermometer',
  'INS_Pressure_Gauge',
  'INS_Odometer',
  'INS_Indicator_5',
  'INS_Indicator_3',
  'INS_Indicator_2',
  'INS_Behind_a_Local_Control',
  'INS_On_Local_Control_Panel',
  'INS_On_Central_Control',
  'INS_Computer_Indicator',
  'INS_Shared_Indicator_2',
  'INS_Behind_Control',
  'HTX_Vent',
  'HTX_Thin-film_Evaporator',
  'HTX_Silencer',
  'HTX_Combustion_Chamber',
  'HTX_light_water_Station',
  'HTX_Hose_Reel',
  'HTX_Extractor_Hood',
  'HTX_Condenser',
  'HTX_Vertical_Turbine',
  'HTX_Fired_Heater',
  'HTX_Oil_Burner',
  'HTX_Boiler',
  'HTX_U-Tube_Heat_Exchanger',
  'HTX_Briquetting_Machine',
  'HTX_Air-cooled_Exhanger',
  'HTX_Spiral_Heat_Exchanger',
  'HTX_Hairpin_Exchanger',
  'HTX_Double-Pipe_Heat_Exchanger',
  'HTX_Single-Pass_Heat_Exchanger',
  'HTX_Single-Plate_Heat_Exchanger',
  'HTX_Reboiler',
  'HTX_Reboiler_Heat_Exchanger',
  'HTX_Kettle_Heat_Exchanger',
  'HTX_Plate_Heat_Exchanger',
  'HTX_Floating-Head_Heat_Exchanger',
  'HTX_Finned-Tubes_Heat_Exchanger',
  'HTX_Coil-Tubes_Heat_Exchanger',
  'HTX_Straight_Tubes_Heat_Exchanger',
  'HTX_Electric_Heater',
  'HTX_Fin-fan_Coller',
  'HTX_Induced_Flow_Air_Cooler',
  'HTX_Air-Blown_Cooler',
  'HTX_Cooler',
  'HTX_Shell_and_Tube_Heat_III',
  'HTX_Shell_and_Tube_Heat_II',
  'HTX_Shell_and_Tube_Heat',
  'HTX_Exchanger',
  'HTX_Heater',
  'HTX_Heat_Exchanger_III',
  'HTX_Heat_Exchanger_II',
  'HTX_Heat_Exchanger',
  'HTX_Induced-Draft_Cooling_Tower',
  'HTX_Front_Draft_Cooling_Tower',
  'HTX_Spray_Cooler',
  'HTX_Cooling_Tower_III',
  'HTX_Cooling_Tower_II',
  'HTX_Cooling_Tower',
  'HTX_Dryer',
  'HTX_Plate_and_Frame_Heat_Exchanger',
  'HTX_TEMA_TYPE_BKU',
  'HTX_TEMA_TYPE_NEN',
  'HTX_TEMA_TYPE_AEL',
  'HTX_TEMA_TYPE_AEM',
  'HTX_TEMA_TYPE_BEU',
  'HTX_TEMA_TYPE_BEM',
  'GEN_Suction_Filter',
  'GEN_Rotary_Filter',
  'GEN_Filter_V',
  'GEN_Filter_IV',
  'GEN_Oxygen-enriched_Filter',
  'GEN_Primary_Mid-effect_Filter',
  'GEN_High_Efficiency_Filter',
  'GEN_The_Filter',
  'GEN_Air_Filter_II',
  'GEN_Air_Filter',
  'GEN_Press_Filter',
  'GEN_Ion-Exchanger_Filter',
  'GEN_BIO_Filter',
  'GEN_Rotary_Liquid_Filter',
  'GEN_Fixed_Bed_Liquid_Filter',
  'GEN_Liquid_Filter',
  'GEN_HEPA_Gas_Filter',
  'GEN_Fixed_Bedl_Air_Filter',
  'GEN_Roll_Air_Filter',
  'GEN_Carteidge_Gas_Filter',
  'GEN_Gas_Filter',
  'GEN_Filter_III',
  'GEN_Filter_II',
  'GEN_Band-pass_Filter',
  'GEN_Low-pass_Filter',
  'GEN_High-pass_Filter',
  'GEN_Filter',
  'GEN_Mode_Filter_Indication',
  'GEN_Mode_Filter',
  'FIL_Suction_Filter',
  'FIL_Rotary_Filter',
  'FIL_Filter_V',
  'FIL_Filter_IV',
  'FIL_Oxygen-enriched_Filter',
  'FIL_Primary_Mid-effect_Filter',
  'FIL_High_Efficiency_Filter',
  'FIL_The_Filter',
  'FIL_Air_Filter_II',
  'FIL_Air_Filter',
  'FIL_Press_Filter',
  'FIL_Ion-Exchanger_Filter',
  'FIL_BIO_Filter',
  'FIL_Rotary_Liquid_Filter',
  'FIL_Fixed_Bed_Liquid_Filter',
  'FIL_Liquid_Filter',
  'FIL_HEPA_Gas_Filter',
  'FIL_Fixed_Bedl_Air_Filter',
  'FIL_Roll_Air_Filter',
  'FIL_Carteidge_Gas_Filter',
  'FIL_Gas_Filter',
  'FIL_Filter_III',
  'FIL_Filter_II',
  'FIL_Band-pass_Filter',
  'FIL_Low-pass_Filter',
  'FIL_High-pass_Filter',
  'FIL_Filter',
  'FIL_Mode_Filter_Indication',
  'FIL_Mode_Filter',
  'DRY_Moving_Shelf_Dryer',
  'DRY_Spray_Dryer',
  'DRY_Heat_Consumer',
  'DRY_Drying_Oven',
  'DRY_Generator',
  'DRY_Motor_Generator',
  'DRY_Roller_Conveyor_Belt_Dryer',
  'DRY_Fluidized_Bed_Dryer',
  'DRY_Dryer',
  'CRU_Hammer_Crusher_II',
  'CRU_Vibration_Crusher',
  'CRU_Cone_Crusher',
  'CRU_Roller_Crusher',
  'CRU_Jaw_Crusher',
  'CRU_Impact_Crusher',
  'CRU_Hammer_Crusher',
  'CRU_Various_Crusher',
  'CRU_Fine_Crusher',
  'CRU_Medium_Crusher',
  'CRU_Coarse_Crusher',
  'CRU_Crusher',
  'COM_Turbo_Compressor',
  'COM_Screw_Compressor',
  'COM_AC_Air_Compressor',
  'COM_Air_Compressor',
  'COM_Axial_Compressor',
  'COM_Selectable_Compressor',
  'COM_Centrifugal_Compressor_IV',
  'COM_Centrifugal_Compressor_III',
  'COM_Centrifugal_Compressor_II',
  'COM_Compressor_Silencer',
  'COM_Reciprocating_Compressor_III',
  'COM_Roller_Vane_Compressor',
  'COM_Piston_Compressor',
  'COM_Ejector_Compressor',
  'COM_Diaphragm_Compressor',
  'COM_Centrifugal_Compressor',
  'COM_Compressor_Vacume_Pump',
  'COM_Compressor_II',
  'COM_Compressor',
  'CEN_Centrifugal_Pump_VI',
  'CEN_Centrifugal_Fan',
  'CEN_Centrifugal_Pump_V',
  'CEN_Centrifugal_Pump_IV',
  'CEN_Centrifugal_Pump_II',
  'CEN_Centrifugal_Pump_III',
  'CEN_Centrifuge',
  'CEN_Centrifugal_Blower',
  'CEN_Centrifuge_Skimmer',
  'CEN_Centrifuge_Separator_Disc',
  'CEN_Centrifuge_Screw-Perforated-shell',
  'CEN_Centrifuge_Pusher',
  'CEN_Centrifuge_Perforated_Shell',
  'CEN_Centrifuge_High-speed',
  'CEN_Centrifuge_Solid_Shell',
  'CEN_Centrifuge_Screw',
  'CEN_Centrifugal_Compressor_III',
  'CEN_Centrifugal_Compressor_II',
  'CEN_Centrifugal_Compressor',
  'CEN_Centrifugal_Pump',
  // Additional symbol categories
  'gate_valve',
  'control_valve',
  'valve',
  'lmi',
  'reducer',
  'pump',
  'general',
  'instrumentation',
  'tank',
  'arrow',
  'TAG',
  'REDUCER',
  'PUMP',
  'COMPRESSOR',
  'HEAT EXCHANGER',
  'VESSEL',
  'COLUMN',
  'REACTOR',
  'VALVE',
  'ELECTRIC',
  'HYDRAULIC',
  'GATE VALVE',
  'CHECK VALVE',
  'CONTROL VALVE',
  'BALL VALVE',
  'BUTTERFLY VALVE',
  'RELIEF VALVE',
  'GLOBE VALVE',
  'SAFETY RELIEF VALVE',
  'PNEUMATIC ACTUATED BUTTERFLY VALVE',
  'FLOW INDICATOR',
  'FLOW TRANSMITTER',
  'CONNECTOR',
  'TANK',
  'THREE WAY VALVE',
  'ACTUATOR',
  'FLANG SET'
]

const colors = defaultColorNames.filter(
  (color) => !['black', 'white', 'grey'].includes(color)
)

export const classRecords = Object.fromEntries(
  classNames.map((name, idx) => {
    const colorName = colors[idx % colors.length]

    const { category, label } = parseName(name)
    const color = nodeColors[idx % nodeColors.length] // uses our colors[200]

    return [
      name,
      {
        color,
        colorName,
        category,
        label
      },
    ]
  })
)

export const d3ClassRecords = Object.fromEntries(
  classNames.map((name, idx) => {
    const color = nodeColors[idx % nodeColors.length]

    const { category, label } = parseName(name)

    return [
      name,
      {
        color,
        category,
        label
      },
    ]
  })
)